import {NeoAGgrid} from "@/components/table/neo-table/neo-ag-grid";
import {InvoiceTableConfig} from "@/data/routePlan/billingHistory.config";
import {
  Button,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter
} from "@nextui-org/react";

export const RoutePlanBillingHistory = ({
  setShowBillingHistory,
  showBillingHistory
}: any) => {
  const data = InvoiceTableConfig;

  //const {isOpen, onOpen, onOpenChange} = useDisclosure();
  return (
    <>
      <Drawer
        isOpen={showBillingHistory}
        //placement={"right"}
        size={"5xl"}
        // onOpenChange={onOpenChange}
      >
        <DrawerContent>
          <>
            <DrawerBody>
              <NeoAGgrid table={data.table}></NeoAGgrid>
            </DrawerBody>
            <DrawerFooter>
              <Button
                color="danger"
                variant="light"
                onPress={() => setShowBillingHistory(false)}
              >
                Close
              </Button>
              <Button
                color="primary"
                onPress={() => setShowBillingHistory(false)}
              >
                Action
              </Button>
            </DrawerFooter>
          </>
        </DrawerContent>
      </Drawer>
    </>
  );
};
